import { effect, inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectTokenPayload } from '../auth/auth.reducer';
import { CreditsSocketService } from '../../sockets/credits-socket.service';

@Injectable()
export class CreditsEffects {
  private store = inject(Store);
  private jwtPayload = this.store.selectSignal(selectTokenPayload);
  private creditsSocketService = inject(CreditsSocketService);

  payloadEffect = effect(() => {
    const payload = this.jwtPayload();
    if (payload) {
      this.creditsSocketService.connect();
    }
  });
}
